import * as React from 'react';
import { UserMessage } from 'app/types-shared';
import { getUserMessage } from 'app/infrastructure/notifications/user-messages/get-user-message';

interface FavouriteErrorProps {
	error: UserMessage[];
}

export const FavouriteError = ({ error }: FavouriteErrorProps) => (
	<div className="alert">
		{getUserMessage(error)}
	</div>
);
